import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const Column = ({ title, action, className, children }) => {
  const showHeader = Boolean(title || action);

  return (
    <div className={cn(styles.root, className)}>
      {showHeader && (
        <header className={styles.header}>
          {Boolean(title) && <h3 className={styles.title}>{title}</h3>}
          {action}
        </header>
      )}

      {children}
    </div>
  );
};

export default Column;
